import { useI18n } from 'vue-i18n';
import { formatError as baseFormatError } from '#layers/base/public';

export function useErrorFormatter() {
	const i18n = useI18n();

	const formatError = (error: any): string => {
		return baseFormatError(error, i18n);
	};

	return {
		formatError,
	};
}
